import { render, staticRenderFns } from "./ViewtzdeditTable.vue?vue&type=template&id=a4d07f6e&"
import script from "./ViewtzdeditTable.vue?vue&type=script&lang=js&"
export * from "./ViewtzdeditTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports